import { Component, OnInit, ViewChild } from '@angular/core';
import { Player } from '../../objects/player';
import { PlayerService } from '../../services/player.service';
import { MatTabGroup } from '@angular/material/tabs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PlayerOptIn } from '../../objects/player-opt-in';
import { Round } from '../../objects/round';
import { UtilityService } from 'src/app/services/utility.service';
import { CoursesService } from 'src/app/services/courses.service';

var activeIndex: number;

@Component({
  selector: 's18-player-profile',
  templateUrl: './player-profile.component.html',
  styleUrls: ['./player-profile.component.scss']
})
export class PlayerProfileComponent implements OnInit {
  @ViewChild(MatTabGroup, { static: true }) tabs: MatTabGroup;

  player: Player;
  handicap_rounds: any;
  tournamentRounds: Round[];
  playerCopy: string;
  optInOptions: PlayerOptIn;
  optInCopy: string;
  league_type_id = '2';
  group_type_id = '0,1';
  saving = false;
  allStates: { state: string };
  courses: { coursename: string, course_id: string };


  constructor(
    private playerService: PlayerService,
    private courseService: CoursesService,
    private snackBar: MatSnackBar,
    private utility: UtilityService
  ) { }

  ngOnInit() {
    if (activeIndex) {
      this.tabs.selectedIndex = activeIndex;
    }
    this.player = this.playerService.getLoggedInPlayerInfo();
    this.playerCopy = JSON.stringify(this.player);
    this.getOptInOptions();
    this.getRevisionRounds();
    //this.getTournamentRounds();
    this.courseService.getStates(this.player.player_id.toString())
      .subscribe(resp => this.parseStates(resp));
    if (this.player.state) {
      this.getCourses();
    }
  }

  getToken() {
    this.playerService.getToken()
      .subscribe(resp => console.log(resp.d));
  }

  getTournamentRounds() {
    this.playerService.getAllTournamentRounds(this.player.player_id.toString())
      .subscribe(resp => {
        this.tournamentRounds = JSON.parse(resp.d).result;
      });
  }

  getRevisionRounds() {
    this.playerService.getRevisionRounds(this.player.player_id.toString())
      .subscribe(resp => {
        this.handicap_rounds = JSON.parse(resp.d).scores;
        console.log(this.handicap_rounds);
      });
  }


  isDirty(): boolean {
    return this.playerCopy !== JSON.stringify(this.player) ||
      this.optInCopy !== JSON.stringify(this.optInOptions);
  }

  toggleOption(optionName: string) {
    let option = +this.optInOptions[optionName];
    if (option === 1) {
      this.optInOptions[optionName] = '0';
    } else {
      this.optInOptions[optionName] = '1';
    }
  }

  getOptInOptions() {
    this.playerService.getPlayerOptInOptions(this.player.player_id.toString())
      .subscribe(resp => {
        this.optInOptions = JSON.parse(resp.d).user_optin;
        this.optInCopy = JSON.stringify(this.optInOptions)
      });
  }

  parseStates(resp: any) {
    this.allStates = JSON.parse(resp.d).states;
  }

  getCourses() {
    this.courseService.getCoursesForState(this.player.state).subscribe(resp => this.courses = JSON.parse(resp.d).courses);
  }

  selectionChange(event: any) {
    activeIndex = event.index;
  }

  updatePlayer() {
    this.saving = true;
    this.playerService.updatePlayer(this.player).subscribe(resp => {
      this.saving = false;
      var result = JSON.parse(resp.d).response;
      if (result !== 'ok') {
        this.snackBar.open(result, null, { duration: 3000 });
        return;
      }
      this.updateOptIn();
      this.playerService.setLoggedInPlayerInfo(this.player);
      this.playerCopy = JSON.stringify(this.player);
    });
  }

  updateOptIn() {
    this.saving = true;
    this.playerService.savePlayerOptInOptions(this.optInOptions)
      .subscribe(resp => {
        this.saving = false;
        var result = JSON.parse(resp.d).response;
        if (result != 'OK') {
          this.snackBar.open(result, null, { duration: 3000 });
          return;
        }
        this.optInCopy = JSON.stringify(this.optInOptions);
      });
  }
}
